import React, {
	createContext,
	memo,
	useCallback,
	useEffect,
	useReducer
} from 'react';
import PropTypes from 'prop-types';

import { actionDeclarer } from '../services/actionDeclarer';

export default ( {
	reducer,
	initialState,
	controller,
	onInit,
	onCleanup
} ) => {
	const StateContext = createContext();
	const ActionContext = createContext();

	const { SET_INITIALIZED } = actionDeclarer;

	const contextReducer = (
		state,
		{
			type,
			payload
		}
	) => {
		switch ( type ) {
			case SET_INITIALIZED: {
				return {
					...state,
					initialized: payload
				};
			}

			default: {
				return reducer(
					state,
					{
						type,
						payload
					}
				);
			}
		}
	};

	const Provider = ( { children, ...props } ) => {
		const [ state, dispatch ] = useReducer(
			contextReducer,
			{
				initialized: false,
				...initialState,
				...props
			}
		);

		const init = useCallback( async () => {
			if ( onInit ) {
				await onInit( dispatch );
			}

			SET_INITIALIZED( dispatch, controller.signal )( true );
		}, [] );

		useEffect( () => {
			init();

			return onCleanup;
		}, [ init ] );

		return (
			<StateContext.Provider value={ state }>
				<ActionContext.Provider value={ dispatch }>
					{ children }
				</ActionContext.Provider>
			</StateContext.Provider>
		);
	};

	Provider.propTypes = { children: PropTypes.node.isRequired };

	return {
		controller,
		StateContext,
		ActionContext,
		Provider: memo( Provider )
	};
};
